export default __webpack_public_path__ + "static/media/InivteGrp.ffb9a8dc.png";